import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing auth on mount
    const adminToken = localStorage.getItem('adminToken');
    const partnerUser = sessionStorage.getItem('partnerUser');
    
    if (adminToken) {
      setUser({ type: 'admin', token: adminToken });
    } else if (partnerUser) {
      setUser({ type: 'partner', data: JSON.parse(partnerUser) });
    }
    setLoading(false);
  }, []);

  const loginAdmin = (token) => {
    localStorage.setItem('adminToken', token);
    setUser({ type: 'admin', token });
  };

  const loginPartner = (partnerData) => {
    sessionStorage.setItem('partnerUser', JSON.stringify(partnerData));
    setUser({ type: 'partner', data: partnerData });
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('partnerUser');
    sessionStorage.clear();
    setUser(null);
  };

  const value = {
    user,
    loading,
    loginAdmin,
    loginPartner,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.type === 'admin',
    isPartner: user?.type === 'partner'
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};